// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"dc0e69ae9f72ab0d8275","966":"83566026b042a7a8a30e"}[chunkId] + ".js";
};